import PropTypes from "prop-types";
import React from "react";

import { Loading, PageGrid, Svg } from "@swa-ui/core";
import { classNames } from "@swa-ui/string";

import styles from "./DotcomHeaderLoading.module.scss";

const DESKTOP_LOGO_HEIGHT = "34";
const DESKTOP_LOGO_HEART_HEIGHT = "34";
const DESKTOP_LOGO_WIDTH = "191";
const MOBILE_LOGO_HEIGHT = "31";
const MOBILE_LOGO_HEART_HEIGHT = "24";
const MOBILE_LOGO_WIDTH = "125";

/**
 * DotcomHeaderLoading renders a skeleton of the desktop global header with a hardcoded copy of the logo SVG.
 */
export const DotcomHeaderLoading = (props) => {
  const { mobileLogoLeftAlign = false, type = "desktop" } = props;
  const isDesktop = type === "desktop";

  return isDesktop ? renderDesktopFallback() : renderMobileFallback();

  function renderDesktopFallback() {
    return (
      <PageGrid sides={true} className={classNames(styles.dotcomHeaderLoading, styles.desktop)}>
        <div {...getContainerProps()}>
          {renderSvgLogo()}
          <div className={styles.menuLoadingContainer}>
            <Loading {...getDesktopMenuLoadingProps(true)} />
            <Loading {...getDesktopMenuLoadingProps()} />
          </div>
        </div>
      </PageGrid>
    );
  }

  function renderMobileFallback() {
    return (
      <PageGrid sides={true} className={classNames(styles.dotcomHeaderLoading, styles.mobile)}>
        <div {...getContainerProps()}>
          <div />
          {renderSvgLogo()}
          <div />
        </div>
      </PageGrid>
    );
  }

  function renderSvgLogo() {
    return (
      <div className={styles.logoContainer}>
        <Svg {...getSvgLogoProps()} />
        <Svg {...getSvgHeartProps()} />
      </div>
    );
  }

  function getContainerProps() {
    return {
      className: classNames(styles.container, {
        [styles.desktop]: isDesktop,
        [styles.left]: mobileLogoLeftAlign,
        [styles.mobile]: !isDesktop,
      }),
    };
  }

  function getDesktopMenuLoadingProps(isSmall = false) {
    return {
      className: isSmall ? styles.menuLoadingSmall : styles.menuLoadingLarge,
      height: "xsmall",
      shape: "roundedRectangle",
    };
  }

  function getSvgHeartProps() {
    return {
      className: classNames(styles.logo, styles.heart, { [styles.mobile]: !isDesktop }),
      height: isDesktop ? DESKTOP_LOGO_HEART_HEIGHT : MOBILE_LOGO_HEART_HEIGHT,
      name: "Heart",
    };
  }

  function getSvgLogoProps() {
    return {
      className: classNames(styles.logo, { [styles.mobile]: !isDesktop }),
      fillColor: isDesktop ? "primary-500" : "neutral-900",
      height: isDesktop ? DESKTOP_LOGO_HEIGHT : MOBILE_LOGO_HEIGHT,
      name: "Logo",
      width: isDesktop ? DESKTOP_LOGO_WIDTH : MOBILE_LOGO_WIDTH,
    };
  }
};

DotcomHeaderLoading.displayName = "DotcomHeaderLoading";
DotcomHeaderLoading.propTypes = {
  /**
   * Whether to left align the mobile logo to match when the mobile header has the
   *  notification center enabled.
   * */
  mobileLogoLeftAlign: PropTypes.bool,

  /** Whether to display the desktop or mobile loading component. */
  type: PropTypes.oneOf(["desktop", "mobile"]),
};
